module.exports = __webpack_public_path__ + "img/down-gansu3.4b53671c.jpg";